import React from 'react';
import PropTypes from 'prop-types';
import Auth from '@Services/Auth';
import { FEATURES } from '@Constants/rx-ui/constants';
import UserDatabases from '@Services/UserDatabases';
import Button from '@Components/Button';
import './ResultsFiltersHeader.custom.scss';
import './ResultsFiltersHeader.theme.scss';

export default function ResultsFiltersHeader(props) {
  const { databaseId, limitTo, exclude, disableButtons } = props;
  const isExcludeButtonHidden = UserDatabases.isRCSDatabase(databaseId) && Auth.isFeatureEnabled(FEATURES.hideRCSFiltersExcludeButton);

  return (
    <section className="results-filters-header">
      <span>Filters</span>
      <div className="results-filters-header-buttons">
        <Button
          disabled={disableButtons}
          buttonConfig={{ type: 'primary', size: 'sm', label: 'Limit to', e2eName: 'results-filters-limit' }}
          iconConfig={{ name: 'chevron-right', size: 'tiny' }}
          onClick={limitTo}
        />
        {!isExcludeButtonHidden && (
          <Button
            disabled={disableButtons}
            buttonConfig={{ type: 'primary', size: 'sm', label: 'Exclude', e2eName: 'results-filters-exclude' }}
            iconConfig={{ name: 'chevron-right', size: 'tiny' }}
            onClick={exclude}
          />
        )}
      </div>
    </section>
  );
}

export const propTypes = {
  databaseId: PropTypes.string.isRequired,
  limitTo: PropTypes.func.isRequired,
  exclude: PropTypes.func.isRequired,
  disableButtons: PropTypes.bool.isRequired,
};

ResultsFiltersHeader.propTypes = propTypes;
